<template>
  <div class="contents main">
      <section>
        <h2 class="page_title">접수현황</h2>
        <article>
          <ul class="step">
            <li v-for="(item, index) in stepList" :key="index">
              <div class="info">
                <div class="count">{{ item.count }}</div>
                <div class="label">{{ item.label }}</div>
              </div>
              <b-icon icon="chevron-right"></b-icon>
            </li>
          </ul>
        </article>
      </section>
      <div class="dash_contents">
        <section class="medi">
          <h2 class="page_title">약재 현황 <router-link to="" class="title_more">더보기</router-link></h2>
          <article>
            <ul class="simple_title">
              <li>약재</li>
              <li>원산지</li>
              <li>재고량</li>
            </ul>
            <ul class="simple_grid">
                <li v-for="( medi, index ) in mediList" :key="index">
                  <p class="ell"> {{ medi.medicine }}</p>
                  <p class="ell"> {{ medi.origin }}</p>
                  <p class="ell"> {{ medi.quantity }}</p>
                </li>
            </ul>
          </article>
        </section>
        <section class="wrapper">
          <h2 class="page_title">포장지 현황 <router-link to="" class="title_more">더보기</router-link></h2>
          <article>
            <ul class="simple_title">
              <li>포장지</li>
              <li>재고량</li>
            </ul>            
              <ul class="simple_grid">
                <li v-for="( wra, index ) in wrapperList" :key="index">
                  <p class="ell">{{ wra.wrapper }} &nbsp; {{ index + 1 }}</p>
                  <p class="ell">{{ wra.quantity }}</p>
                </li>
              </ul>
          </article>
        </section>
        <section class="notice">
          <h2 class="page_title">공지사항 <router-link to="" class="title_more">더보기</router-link></h2>
          <article>
            <ul>
              <li></li>
            </ul>           
            <ul class="simple_grid">
              <li v-for="( noti, index ) in noticeList" :key="index">
                <p class="title ell al">{{ noti.title }}</p>
                <p class="date ar">{{ noti.date }}</p>
              </li>
            </ul>
          </article>
        </section>
      </div>
    </div>
</template>

<script>
  import axios from 'axios'
  import { stepList, mediList, noticeList, wrapperList } from "@/data/dashboardList"
  export default {
    name: 'AdminMain',
    data() {
      return {
        stepList: stepList,
        mediList: mediList,
        wrapperList: wrapperList,
        noticeList: noticeList,
      }
    },
    mounted(){ 
        this.fn_intake_status();
    },
    methods : {
      fn_intake_status(){

          axios
              .post("/api/admin/dashboard/getIntakeStaus", this.searchInfo)
              .then((res) => {
                  console.log("@@@@ res : %o",res);
                  this.orderList = res.data.orderList;

                  console.log("@@@@ orderList : %o",this.orderList);

                  this.searchInfo.pageInfo.totPage = res.data.totCnt;
                  
                  if(this.searchInfo.pageInfo.totPage> 0){
                      this.pagingShow = true;                          
                  }                        

              })
              .catch((err) => console.log(err));
      },
    }
  }
</script>